import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FiSend, FiCheck } from "react-icons/fi";

import "./contact.css";

const Contact = () => {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const sendEmail = (event) => {
    event.preventDefault();

    if (form.current.elements.company.value) {
      setSent(true);
      event.target.reset();
      setTimeout(() => setSent(false), 4000);
      return;
    }

    setSending(true);

    emailjs
      .sendForm(
        "service_ztrtv0b",
        "template_l41mneo",
        form.current,
        "SxPQ8QjBRArLQtKtA"
      )
      .then(
        () => {
          setSent(true);
          setSending(false);
          event.target.reset();
          setTimeout(() => setSent(false), 4000);
        },
        (error) => {
          console.log(error.text);
          setSending(false);
        }
      );
  };

  return (
    <section id="contact" aria-labelledby="contact-heading">
      <h5>Contact</h5>
      <h2 id="contact-heading">Let's talk</h2>

      <div className="container contact__container reveal">
        <div className="contact__info">
          <p className="contact__text">
            Have a project in mind or just want to chat? Drop me a message
            and I'll get back to you.
          </p>
        </div>

        <form ref={form} onSubmit={sendEmail} className="contact__form glass">
          <div className="contact__field contact__field--honeypot" aria-hidden="true">
            <label htmlFor="contact-company">Company</label>
            <input
              id="contact-company"
              type="text"
              name="company"
              tabIndex="-1"
              autoComplete="off"
            />
          </div>

          <div className="contact__field">
            <label htmlFor="contact-name">Name</label>
            <input
              id="contact-name"
              type="text"
              name="name"
              placeholder="Your name"
              required
            />
          </div>

          <div className="contact__field">
            <label htmlFor="contact-email">Email</label>
            <input
              id="contact-email"
              type="email"
              name="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="contact__field">
            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              rows="5"
              placeholder="What's on your mind?"
              required
            />
          </div>

          <button
            type="submit"
            className={`btn btn-primary contact__submit${sent ? " contact__submit--sent" : ""}`}
            disabled={sending}
          >
            {sent ? (
              <>
                <FiCheck className="btn__icon" />
                Sent!
              </>
            ) : sending ? (
              "Sending..."
            ) : (
              <>
                Send
                <FiSend className="btn__icon" />
              </>
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
